import { PersonsDependentCommitmentsService_personDependentCommitmentsVersionServiceGetQuery } from '@festina/life-general-types/life/hooks/PersonsDependentCommitmentsService_personDependentCommitmentsVersionServiceGetQuery'

export const useFetchDependentCommitmentsNoSuspense =
  PersonsDependentCommitmentsService_personDependentCommitmentsVersionServiceGetQuery.useQuery
